import React from 'react';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import Button from '../../../components/ui/Button';
import { openCustomerPortal } from '../../../utils/cn';

const FinalCTASection = () => {
  const navigate = useNavigate();

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.15,
      },
    },
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 30 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6,
        ease: 'easeOut',
      },
    },
  };

  return (
    <section className="py-16 lg:py-20 bg-gradient-to-br from-cyan-500 via-blue-600 to-blue-700 text-white relative overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-0 left-0 w-96 h-96 bg-white rounded-full blur-3xl" />
        <div className="absolute bottom-0 right-0 w-96 h-96 bg-white rounded-full blur-3xl" />
      </div>
      <div className="relative z-10 max-w-[1400px] mx-auto px-6 lg:px-12">
        <motion.div
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: "-100px" }}
          variants={containerVariants}
          className="max-w-4xl mx-auto text-center space-y-12">
          
          <motion.div variants={itemVariants} className="space-y-6">
            <h2 className="text-4xl sm:text-5xl lg:text-6xl font-jakarta font-bold leading-[1.1]">
              Ready to Experience Transparent Roofing?
            </h2>
            <p className="text-xl sm:text-2xl text-white/90 leading-relaxed">
              See your roof price in 30 minutes. No sales calls. No pressure. Just transparent pricing.
            </p>
          </motion.div>

          <motion.div 
            variants={itemVariants}
            className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <Button
              size="xl"
              variant="default"
              onClick={() => openCustomerPortal()}
              className="bg-white text-blue-700 hover:bg-gray-100 font-semibold px-10 py-6 text-lg shadow-2xl">
              See Your Roof Price in 30 Minutes
            </Button>
            <Button
              size="xl"
              variant="outline"
              onClick={() => navigate('/how-it-works')}
              className="border-2 border-white text-white hover:bg-white/10 font-semibold px-10 py-6 text-lg">
              Learn How It Works
            </Button>
          </motion.div>

          <motion.p 
            variants={itemVariants}
            className="text-white/80 text-sm">
            Join thousands of homeowners who chose transparency over sales tactics.
          </motion.p>
        </motion.div>
      </div>
    </section>
  );
};

export default FinalCTASection;